export default "__VITE_ASSET__BZJEUw35__"